import { SchedulableItem } from '../interfaces/taskList';
import { Task } from '../interfaces';
import { WorkflowItemCode } from '../../constants';

const markSchedulableItems = (tasks: Task[], itemStatusArray: SchedulableItem[] | undefined): Task[] => {
  let schedulableItemMap: Record<string, SchedulableItem> = {};
  let tasksWithSchedulableStatus = tasks;
  if (itemStatusArray && itemStatusArray.length) {
    schedulableItemMap = itemStatusArray.reduce((acc: Record<string, SchedulableItem>, cur: SchedulableItem) => {
      acc[cur.itemId] = cur;
      return acc;
    }, {});

    tasksWithSchedulableStatus = tasks.map((task) => ({
      ...task,
      items: task.items.map((item) => {
        if (schedulableItemMap[item.id]) {
          return { ...schedulableItemMap[item.id], ...item, isSchedulable: true };
        }
        return item;
      }),
    }));
  }

  return tasksWithSchedulableStatus.map((task) => {
    task.isSchedulable = task.items.some(
      (item) => item.code === WorkflowItemCode.EXPASSES && item.isSchedulable && item.scheduled,
    );
    return task;
  });
};

export default markSchedulableItems;
